<app-add-lane
	(laneUpdated)="laneUpdated($event)"
	[carrierId]="carrierid"
	[editLane]="true"
	[inputConfig]="inputConfig"
	[isDisabled]="false"
	[lane]="lane"
	[oldCarrierId]="!utilService.isNullOrUndefined(carrier) ? carrier.oldCarrierId : null"
	[usePublicCreateLane]="false"
>
</app-add-lane>

<mat-icon
	(click)="!isLaneUpdating && refreshLane(lane.id)"
	style="color: cornflowerblue; cursor: pointer"
>
	refresh
</mat-icon>
<mat-icon (click)="!isLaneUpdating && removeLane(lane.id)" style="color: red; cursor: pointer">
	delete_forever
</mat-icon>

<div *ngIf="enableProjectSearch" fxFlex fxLayoutAlign="end center">
	<button (click)="navigateToProjectsBoard()" class="invited-chip" mat-raised-button>
		Find Projects
	</button>
</div>
